<template>
    <div>
        <nav class="space-x-10 flex border-b border-gray-300 mb-4">
            <slot name="tabs"></slot>
        </nav>

        <div class="pr-4">
            <slot></slot>
        </div>
    </div>
</template>

<script>
	export default {
	    data() {
	        return {
	            sharedState: {
	                activeTab: null,
                }
            }
        },

        provide() {
            return {
                tabsState: this.sharedState
            }
        },

        props: {
	        activateFirst: {
	            type: Boolean,
                default: true
            }
        },

        mounted() {
	        if (this.activateFirst) {
                this.$slots.tabs[0].componentInstance.activateTab()
            }
        }
    }
</script>
